import { cx } from "@ui/utils/cx";
import { PROSE_CLASSES } from "./prose";

export interface RichTextProps {
  children: string | null;
  className?: string;
}

export function RichText({ children, className }: RichTextProps) {
  if (!children) return null;

  return (
    <div
      className={cx(PROSE_CLASSES, className)}
      // biome-ignore lint/security/noDangerouslySetInnerHtml: HTML is sanitized by Action Text on the server
      dangerouslySetInnerHTML={{ __html: children }}
    />
  );
}
